const makeAddress = (locationCode?: string, buildingName?: string, rackBLI?: string) => 
  `${locationCode??""}${buildingName??""}-${rackBLI??""}`;

export default makeAddress;